module.exports = __webpack_public_path__ + "img/hr-oil-refinery.716e2490.png";